module.exports = __webpack_public_path__ + "static/media/ifa.e1b9ecb8.svg";